import React, { useState, useEffect } from 'react';
import './Wardrobe.css';

const SLOT_LABEL = {
  head: 'На голову',
  neck: 'На шею',
  held: 'В лапы',
  room: 'На полку',
};

function Wardrobe({ patron, inventory, apiBase, onEquip, onColor }) {
  const [palette, setPalette] = useState([]);

  useEffect(() => {
    fetch(`${apiBase}/palette`)
      .then((r) => r.json())
      .then((d) => setPalette(d.palette || []))
      .catch(() => setPalette([]));
  }, [apiBase]);

  const wearable = inventory.filter((i) => i.slot && i.slot !== 'room');
  const shelf = inventory.filter((i) => !i.slot || i.slot === 'room');

  const bySlot = wearable.reduce((acc, item) => {
    (acc[item.slot] = acc[item.slot] || []).push(item);
    return acc;
  }, {});

  return (
    <div className="wardrobe">
      <section className="wardrobe-block">
        <h3>🎨 Свечение</h3>
        <p className="hint">Каким светом горит твой патронус</p>
        <div className="palette">
          {palette.map((c) => (
            <button
              key={c}
              className={`swatch ${patron.color === c ? 'active' : ''}`}
              style={{ background: c }}
              onClick={() => onColor(c)}
              aria-label={`цвет ${c}`}
            />
          ))}
        </div>
      </section>

      {Object.keys(bySlot).length > 0 && (
        <section className="wardrobe-block">
          <h3>👗 Гардероб</h3>
          {Object.entries(bySlot).map(([slot, items]) => (
            <div key={slot} className="slot-group">
              <div className="slot-title">{SLOT_LABEL[slot] || slot}</div>
              <div className="items-row">
                {items.map((item) => (
                  <button
                    key={item.item_id}
                    className={`wear-item ${item.equipped ? 'equipped' : ''}`}
                    onClick={() => onEquip(item.item_id, !item.equipped, item.color)}
                    title={item.name}
                  >
                    <span className="wear-emoji">{item.emoji}</span>
                    <span className="wear-name">{item.name}</span>
                    {item.equipped && <span className="worn-badge">надето</span>}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </section>
      )}

      {shelf.length > 0 && (
        <section className="wardrobe-block">
          <h3>🗄 Полка</h3>
          <p className="hint">Сувениры из твоих дней — нажми, чтобы вспомнить</p>
          <div className="shelf">
            {shelf.map((item) => (
              <div key={item.item_id} className="shelf-item" title={item.memory_txt || item.name}>
                <span className="shelf-emoji">{item.emoji}</span>
                <span className="shelf-name">{item.name}</span>
                {item.memory_txt && (
                  <span className="shelf-memory">«{item.memory_txt}»</span>
                )}
              </div>
            ))}
          </div>
        </section>
      )}

      {inventory.length === 0 && (
        <div className="empty-wardrobe">
          <p>Пока пусто ✨</p>
          <p className="hint">
            Записывай хорошие моменты — из них вырастут вещи, которые можно купить в лавке
          </p>
        </div>
      )}
    </div>
  );
}

export default Wardrobe;
